module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "segment-library"
  }, [_c('div', {
    staticClass: "segment-library-header"
  }, [(!_vm.compact) ? _c('h3', {
    staticClass: "segment-library-title"
  }, [_vm._v("Saved Segment Library")]) : _vm._e(), _vm._v(" "), (!_vm.compact) ? _c('div', {
    staticClass: "segment-library-controls"
  }, [_c('div', {
    staticClass: "segment-library-chips"
  }, _vm._l((_vm.chips), function(chip) {
    return _c('button', {
      key: chip.value,
      staticClass: "segment-chip",
      class: {
        'segment-chip-active': _vm.activeChip === chip.value
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.activeChip = chip.value
        }
      }
    }, [_vm._v(_vm._s(chip.label))])
  }), 0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    staticClass: "form-control segment-library-search",
    attrs: {
      "type": "text",
      "placeholder": "Search by name, journey, customer, country..."
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.folderNames.length) ? _c('nv-select', {
    staticClass: "form-control segment-folder-filter",
    model: {
      value: (_vm.folderFilter),
      callback: function($$v) {
        _vm.folderFilter = $$v
      },
      expression: "folderFilter"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("All folders")]), _vm._v(" "), _vm._l((_vm.folderNames), function(name) {
    return _c('option', {
      key: name,
      domProps: {
        "value": name
      }
    }, [_vm._v(_vm._s(name))])
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "segment-view-toggle"
  }, [_c('button', {
    staticClass: "segment-view-btn",
    class: {
      active: _vm.viewMode === 'list'
    },
    attrs: {
      "type": "button",
      "title": "List view"
    },
    on: {
      "click": function($event) {
        _vm.viewMode = 'list'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-list"
  })]), _vm._v(" "), _c('button', {
    staticClass: "segment-view-btn",
    class: {
      active: _vm.viewMode === 'card'
    },
    attrs: {
      "type": "button",
      "title": "Card view"
    },
    on: {
      "click": function($event) {
        _vm.viewMode = 'card'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-th-large"
  })])])], 1) : _vm._e()]), _vm._v(" "), (_vm.loading) ? _c('BlockUI', [_c('i', {
    staticClass: "fa fa-cog fa-spin fa-3x fa-fw"
  }), _c('br'), _vm._v("Please wait...")]) : _vm._e(), _vm._v(" "), (!_vm.loading && !_vm.segments.length) ? _c('div', {
    staticClass: "segment-library-empty"
  }, [_vm._v("No saved segments yet.")]) : (!_vm.loading && !_vm.filteredSegments.length) ? _c('div', {
    staticClass: "segment-library-empty"
  }, [_vm._v("\n    No segments match your filters.\n    "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.clearFilters.apply(null, arguments)
      }
    }
  }, [_vm._v("Clear filters")])]) : _vm._e(), _vm._v(" "), (_vm.showList && _vm.visibleSegments.length) ? _c('table', {
    staticClass: "table segment-list-table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.visibleSegments), function(segment) {
    return _c('tr', {
      key: segment.id
    }, [_c('td', {
      staticClass: "segment-list-name"
    }, [_vm._v(_vm._s(segment.queryName))]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "segment-card-type-badge",
      class: _vm.typeBadgeClass(segment)
    }, [_vm._v(_vm._s(_vm.typeLabel(segment)))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.journeyFor(segment) || '—'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s((segment.criteria && segment.criteria.customer) || '—'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(segment.countryName || '—'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.userCount(segment)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(segment.folderName || '—'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(segment.createdAt)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(segment.updatedAt)))]), _vm._v(" "), _c('td', {
      staticClass: "segment-list-actions"
    }, [_c('router-link', {
      staticClass: "btn btn-sm btn-default",
      attrs: {
        "to": _vm.editLink(segment)
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    }), _vm._v(" Edit")]), _vm._v(" "), (_vm.copyLink(segment)) ? _c('router-link', {
      staticClass: "btn btn-sm btn-default",
      attrs: {
        "to": _vm.copyLink(segment)
      }
    }, [_c('i', {
      staticClass: "fa fa-copy"
    }), _vm._v(" Copy")]) : _vm._e(), _vm._v(" "), _c('router-link', {
      staticClass: "btn btn-sm btn-primary",
      attrs: {
        "to": "/opportunity"
      }
    }, [_vm._v("Use in campaign")])], 1)])
  }), 0)]) : _vm._e(), _vm._v(" "), (!_vm.showList) ? _c('div', {
    staticClass: "segment-library-grid"
  }, _vm._l((_vm.visibleSegments), function(segment) {
    return _c('div', {
      key: segment.id,
      staticClass: "segment-card"
    }, [_c('div', {
      staticClass: "segment-card-header"
    }, [_c('span', {
      staticClass: "segment-card-name"
    }, [_vm._v(_vm._s(segment.queryName))]), _vm._v(" "), _c('span', {
      staticClass: "segment-card-type-badge",
      class: _vm.typeBadgeClass(segment)
    }, [_vm._v(_vm._s(_vm.typeLabel(segment)))])]), _vm._v(" "), _c('div', {
      staticClass: "segment-card-description"
    }, [_vm._v(_vm._s(_vm.describe(segment)))]), _vm._v(" "), (_vm.tagsFor(segment).length) ? _c('div', {
      staticClass: "segment-card-tags"
    }, _vm._l((_vm.tagsFor(segment)), function(tag) {
      return _c('span', {
        key: tag,
        staticClass: "segment-card-tag"
      }, [_vm._v(_vm._s(tag))])
    }), 0) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "segment-card-meta"
    }, [_c('span', {
      attrs: {
        "title": "User count"
      }
    }, [_c('i', {
      staticClass: "fa fa-users"
    }), _vm._v(" " + _vm._s(_vm.userCount(segment)))]), _vm._v(" "), (_vm.journeyFor(segment)) ? _c('span', {
      attrs: {
        "title": "Journey"
      }
    }, [_c('i', {
      staticClass: "fa fa-sitemap"
    }), _vm._v(" " + _vm._s(_vm.journeyFor(segment)))]) : _vm._e(), _vm._v(" "), _c('span', {
      attrs: {
        "title": "Market"
      }
    }, [_c('i', {
      staticClass: "fa fa-globe"
    }), _vm._v(" " + _vm._s(segment.countryName || '—'))])]), _vm._v(" "), _c('div', {
      staticClass: "segment-card-actions"
    }, [_c('router-link', {
      staticClass: "btn btn-sm btn-default",
      attrs: {
        "to": _vm.editLink(segment)
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    }), _vm._v(" Edit")]), _vm._v(" "), (_vm.copyLink(segment)) ? _c('router-link', {
      staticClass: "btn btn-sm btn-default",
      attrs: {
        "to": _vm.copyLink(segment)
      }
    }, [_c('i', {
      staticClass: "fa fa-copy"
    }), _vm._v(" Copy")]) : _vm._e(), _vm._v(" "), _c('router-link', {
      staticClass: "btn btn-sm btn-primary",
      attrs: {
        "to": "/opportunity"
      }
    }, [_vm._v("Use in campaign")])], 1)])
  }), 0) : _vm._e(), _vm._v(" "), (!_vm.compact && _vm.filteredSegments.length) ? _c('div', {
    staticClass: "segment-pagination"
  }, [_c('span', {
    staticClass: "segment-pagination-info"
  }, [_vm._v(_vm._s(_vm.rangeStart) + "–" + _vm._s(_vm.rangeEnd) + " of " + _vm._s(_vm.filteredSegments.length))]), _vm._v(" "), _c('nv-select', {
    staticClass: "form-control segment-page-size",
    model: {
      value: (_vm.pageSize),
      callback: function($$v) {
        _vm.pageSize = _vm._n($$v)
      },
      expression: "pageSize"
    }
  }, _vm._l((_vm.pageSizes), function(n) {
    return _c('option', {
      key: n,
      domProps: {
        "value": n
      }
    }, [_vm._v(_vm._s(n) + " / page")])
  }), 0), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-default",
    attrs: {
      "type": "button",
      "disabled": _vm.page <= 1
    },
    on: {
      "click": function($event) {
        _vm.page--
      }
    }
  }, [_vm._v("Prev")]), _vm._v(" "), _c('span', [_vm._v("Page " + _vm._s(_vm.page) + " of " + _vm._s(_vm.totalPages))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-default",
    attrs: {
      "type": "button",
      "disabled": _vm.page >= _vm.totalPages
    },
    on: {
      "click": function($event) {
        _vm.page++
      }
    }
  }, [_vm._v("Next")])], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Type")]), _vm._v(" "), _c('th', [_vm._v("Journey")]), _vm._v(" "), _c('th', [_vm._v("Customer")]), _vm._v(" "), _c('th', [_vm._v("Market")]), _vm._v(" "), _c('th', [_vm._v("Users")]), _vm._v(" "), _c('th', [_vm._v("Folder")]), _vm._v(" "), _c('th', [_vm._v("Created")]), _vm._v(" "), _c('th', [_vm._v("Updated")]), _vm._v(" "), _c('th')])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-3020be03","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/audience-builder/ai-audience/SegmentLibrary.vue
// module id = Qndv
// module chunks = 1